











































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import AvailableFieldsCard from './AvailableFieldsCard.vue'

// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

@Component({
  components: { AvailableFieldsCard }
})
export default class EmployerForm extends Vue {
  @Prop({ default: () => ({}) })
  initialData!: any

  @Prop({ default: () => false })
  loading!: boolean

  @Prop({ default: () => [] })
  errors!: { code: string }[]

  template = null

  editor = ClassicEditor

  editorConfig = {
    toolbar: [
      'heading', '|', 'bold', 'italic', 'blockQuote',' |',
      'indent', 'outdent', '|',
      'numberedList', 'bulletedList', 'link', '|',
      'insertTable', 'tableColumn', 'tableRow', 'mergeTableCells','|',
      'undo', 'redo'
    ]
  }

  get hasNameError() {
    return this.errors.filter(i => i.code === 'NAME_TAKEN').length !== 0
  }

  @Watch('initialData')
  initialDataUpdate(val: any) {
    this.template = val
  }

  mounted() {
    this.template = this.initialData
  }

  create() {
    if ((this.$refs.form as any).validate()) {
      this.$emit('create', this.template)
    }
  }

  requiredRule(val: any) {
    return !!val || 'Value is required'
  }
}
